export default __webpack_public_path__ + "static/media/ic_close.f2b9162c.svg";